import { formatCurrency } from '@/shared/utils/formatters'

export function formatMoney(
  value: number | null | undefined,
  ready: boolean
): string {
  if (!ready || value == null || Number.isNaN(value)) return '—'
  return formatCurrency(value)
}

export function formatPct(
  value: number | null | undefined,
  ready: boolean
): string {
  if (!ready || value == null || Number.isNaN(value)) return '—'
  const sign = value > 0 ? '+' : ''
  return `${sign}${value.toFixed(2)}%`
}

export function formatCount(
  value: number | null | undefined,
  ready: boolean
): string {
  if (!ready || value == null || Number.isNaN(value)) return '—'
  return String(value)
}

export function emptyHint(
  ready: boolean,
  loading: boolean
): string | null {
  if (loading && !ready) return 'Reading account data…'
  if (!ready) return 'Awaiting live account data'
  return null
}
